import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const plannerIssueListEmbedRoute: InvariantJiraRoute = {
	name: 'planner-issue-list-embed',
	path: '/jira/planner/issues/embed',
	exact: true,
	query: ['jql'],
};
